export default __webpack_public_path__ + "static/media/warehouse-operative.92232e65.png";